const style = {
  group: {
    margin: `15px -15px`
  },
  checkbox: {
    display: `block`,
    width: `9px`,
    height: `9px`,
    border: `1px solid #ad5151`
  },
  checkbox_check: {
    background: `#ad5151`
  },
  input: {
    padding: `5px 15px`,
    height: `40px`,
    border: `1px solid #ddd`,
    background: `#fff`,
    borderRadius: `0px`,
    fontSize: `14px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/partials/GroupForm/style/form.js